import { Worksheet } from "exceljs";
import { tx as tc } from "./excel-util";

export const tx = (
  col: string,
  value: any,
  worksheet: Worksheet,
  row: number,
  t: any
) => {
  if(value === "No_Data" || value === "No Data" || value === "undefined"){
		tc(col, "NaN", worksheet, row, null);
		return;
  }
  
  if (value === "0" || value === 0) {
    tc(col, 0.00001, worksheet, row, t);
    return;
  }

  tc(col, value, worksheet, row, t);
};
